import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';

export const REPORT_PDF_FILENAME = 'ai-mock-exam-report.pdf';

export async function exportReportPdf(report: HTMLElement, filename = REPORT_PDF_FILENAME): Promise<void> {
  const canvas = await html2canvas(report, {
    backgroundColor: '#080b16',
    scale: 2,
    useCORS: true
  });

  if (canvas.width === 0 || canvas.height === 0) {
    throw new Error('The report could not be rendered for PDF export.');
  }

  const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();
  const imageHeight = (canvas.height * pageWidth) / canvas.width;
  const imageData = canvas.toDataURL('image/png');

  for (let offset = 0; offset < imageHeight; offset += pageHeight) {
    if (offset > 0) pdf.addPage();
    pdf.addImage(imageData, 'PNG', 0, -offset, pageWidth, imageHeight);
  }

  pdf.save(filename);
}
